import store from '@/store'
/**
 * 判断用户是否拥有操作权限
 * 根据传入的权限标识，查看是否存在用户权限标识集合
 * @param perms
 */
export function hasPermission(perms) {
  const userInfo = JSON.parse(sessionStorage.getItem('userinfo'))
  if (userInfo && userInfo.username === 'admin') {
    return true
  }
  let hasPermission = false
  let permissions = store.state.user.perms
  for (let i = 0, len = permissions.length; i < len; i++) {
    if (permissions[i] === perms) {
      hasPermission = true;
      break
    }
  }
  return hasPermission
}




// WEBPACK FOOTER //
// ./src/permission/index.js